import styled from "styled-components";

export const ActionText = styled.a`
  color: #00e;
  font-family: Poppins;
  font-size: 16px;
  text-decoration: underline;
  cursor: pointer;
`;
